export const AUTH_COOKIE_NAME = 'auth'
export const AUTH_COOKIE_NAME_CHECKOUT = 'auth_redirect'
export const BULLY_AUTH_HEADER_NAME = 'rtl-token'
